function initLazyScript(element, callback, threshold = 500) {
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof callback === 'function') {
            callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: `0px 0px ${threshold}px 0px` });

    io.observe(element);
  } else {
    callback();
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('input', (event) => {
      // if (event.target.matches('.custom-range .price-range__sliders input')) {
      if (event.target.matches('.custom-range input')) {
        return;
      }

      this.debouncedOnSubmit(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.hideFilterGroup();

  }

  static hideFilterGroup() {
    const groups = document.querySelectorAll('aside.facets-wrapper details, aside.facets-wrapper .inner-filter-box');

    groups.forEach(item => {
      const labels = item.querySelectorAll('fieldset .facets-layout-list label, .facets__group label');
      const innerBoxes = item.querySelectorAll('.inner-filter-box');

      let allLabelsHidden = labels.length > 0 && Array.from(labels).every(label => label.classList.contains('disabled'));
      let allInnerBoxesHidden = innerBoxes.length > 0 && Array.from(innerBoxes).every(box => box.classList.contains('hidden'));

      if (allLabelsHidden || allInnerBoxesHidden) {
        item.classList.add('hidden', 'disabled');
      } else {
        item.classList.remove('hidden', 'disabled');
      }
    });
  }

  static saveOpenFilters() {
    const openFilters = Array.from(document.querySelectorAll(".facets__title.active"))
      .map(title => Array.from(document.querySelectorAll(".facets__title")).indexOf(title));
    sessionStorage.setItem("openFilters", JSON.stringify(openFilters));
  };

  static subToggle() {
    document.addEventListener('click', (e) => {
      let elem = e.target;
      if (elem.classList.contains('sub-toggle')) {
        elem.classList.toggle('active');
        elem.nextElementSibling.classList.toggle('active');
        FacetFiltersForm.saveOpenFilters();
      }
    })
  }

  static updateActiveFiltersCount() {
    let activeCheckboxes = document.querySelectorAll('#FacetsWrapperDesktop input[type="checkbox"]:checked').length;
    const filterFooter = document.querySelector('.facetc-footer');
    const filterTitlePc = document.querySelector('.active-facets-vertical-filter');
    const priceValues = document.querySelectorAll('.price-block [type="number"]');
    activeCheckboxes += Array.from(priceValues).some(input => input.value.trim() !== '') ? 1 : 0;

    document.querySelectorAll('[active-filters]').forEach((element) => {
      element.textContent = activeCheckboxes;
      if (activeCheckboxes < 1) {
        element.style.display = "";
        filterFooter.classList.remove('show-cta');
        filterTitlePc.classList.remove('show-cta');
      } else {
        element.style.display = "flex";
        filterFooter.classList.add('show-cta');
        filterTitlePc.classList.add('show-cta');
      }
    });
  }

  static toggleLayoutSize() {
    const trigger = document.querySelector('.layout-size__trigger');
    const layoutSize = document.querySelector('.layout-size');
    const radioInputs = document.querySelectorAll('input[name="paginateBy"]');

    radioInputs.forEach(radio => {
      radio.addEventListener('change', function () {
        layoutSize?.classList.remove('open');
        trigger.querySelector('span').innerHTML = radio.value;
      });
    });

    trigger.addEventListener('click', (e) => {
      if (layoutSize) {
        layoutSize.classList.toggle('open');
      }
    });
  }

  static changePagination(html) {
    const radioInputs = document.querySelectorAll('input[name="paginateBy"]');
    function showPagination(paginationNum) {
      if (html) {
        const dataPagination = document.querySelector("[data-custom-pagination]")
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
        const countNum = +count.split(' ')[0]

        if (dataPagination) {
          if (countNum <= paginationNum) {
            dataPagination.style.display = 'none'
          } else {
            dataPagination.style.display = 'flex'
          }
        }
      }
    }

    showPagination(paginationSizeJs)

    radioInputs.forEach((radio) => {
      radio.addEventListener('change', function () {
        let val = this.value;
        let xhr = new XMLHttpRequest();

        if (html) {
          showPagination(val)
        }

        xhr.open('POST', '/cart.js', true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

        let data = "attributes[pagination]=" + encodeURIComponent(val);

        xhr.onload = function () {
          if (xhr.status === 200) {
            const url = new URL(window.location.href);
            url.searchParams.delete("page");
            window.location.href = url.toString();

          } else {
            console.error("Request failed with status: " + xhr.status);
          }
        };

        xhr.send(data);
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.changePagination(html);
        FacetFiltersForm.hideFilterGroup();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.changePagination(html);
    FacetFiltersForm.hideFilterGroup();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static restoreOpenFilters() {
    const openFilters = JSON.parse(sessionStorage.getItem("openFilters")) || [];
    const allTitles = document.querySelectorAll(".facets__title");

    openFilters.forEach(index => {
      const title = allTitles[index];
      if (!title) return;

      const parentDetails = title.closest("details");
      if (parentDetails?.hasAttribute("open")) {
        title.classList.add("active");
        title.nextElementSibling?.classList.add("active");
      } else {
        title.classList.remove("active");
        title.nextElementSibling?.classList.remove("active");
      }
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
    FacetFiltersForm.updateActiveFiltersCount();
    FacetFiltersForm.restoreOpenFilters();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = FacetFiltersForm.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(FacetFiltersForm.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(FacetFiltersForm.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.subToggle();
FacetFiltersForm.updateActiveFiltersCount();
FacetFiltersForm.toggleLayoutSize();
FacetFiltersForm.changePagination();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);



if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = this.querySelector('.price-range-number-min');
      this.maxNumberInput = this.querySelector('.price-range-number-max');
      this.minSliderInput = this.querySelector('.price-range-slider-min');
      this.maxSliderInput = this.querySelector('.price-range-slider-max');
      
      // Store default min/max values during initialization
      this.defaultMin = this.minNumberInput.min || '0';
      this.defaultMax = this.maxNumberInput.getAttribute('max');
      
      // Save default values to sessionStorage and set data attributes for range inputs
      const handle = this.getAttribute('handle');
      if (handle) {
        const defaultStorageKey = `price_range_${handle}_default`;
        const defaultValues = {
          min: this.defaultMin,
          max: this.defaultMax
        };
        sessionStorage.setItem(defaultStorageKey, JSON.stringify(defaultValues));

        // Add data attributes to identify range inputs by handle
        this.minNumberInput.setAttribute('data-range-type', `input_min_${handle}`);
        this.maxNumberInput.setAttribute('data-range-type', `input_max_${handle}`);
      }
      
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));

      this.setInputValue();
    }

    /**
     * Restores saved price range values from session storage if they exist
     * This allows persisting user's selected price range across page reloads
     */
    setInputValue() {
      const handle = this.getAttribute('handle');
      if (handle) {
        // Try to get previously saved range values for this specific price range component
        const storageKey = `price_range_${handle}`;
        const savedValues = sessionStorage.getItem(storageKey);

        if (savedValues) {
          const { min, max } = JSON.parse(savedValues);

          // Update number input and slider values if saved values exist
          if (min !== null && min !== undefined) {
            this.minNumberInput.value = min;
            this.minSliderInput.value = min;
          }

          if (max !== null && max !== undefined) {
            this.maxNumberInput.value = max;
            this.maxSliderInput.value = max;
          }
        }
      }
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
          this.afterUpdate();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
        this.afterUpdate();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min ? this.minSliderInput.value : null;
      this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max ? this.maxSliderInput.value : null;
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      const minValue = parseInt(this.minNumberInput.value, 10);
      const maxValue = parseInt(this.maxNumberInput.value, 10);

      if (minValue > maxValue - 10) {
        if (evt.target === this.minNumberInput) {
          this.maxSliderInput.value = minValue + 10;

          if (maxValue === this.maxValue) {
            this.minSliderInput.value = this.maxValue - 10;
          }
        } else {
          this.minSliderInput.value = maxValue - 10;
        }
      }

      if (maxValue < minValue + 10) {
        if (evt.target === this.maxNumberInput) {
          this.minSliderInput.value = maxValue - 10;

          if (minValue === this.minValue) {
            this.maxSliderInput.value = 10;
          }
        } else {
          this.maxSliderInput.value = minValue + 10;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
      }

      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
      }
    }

    afterUpdate() {
      // Check if component is in alternate mode (used for price range filtering with checkboxes)
      if (this.getAttribute('alternate') != null) {
        clearTimeout(this.rangeTimeoutId);
        this.rangeTimeoutId = setTimeout(() => {
          const handle = this.getAttribute('handle');
          // Get all non-disabled checkbox inputs in the parent fieldset
          const inputList = this.closest('.parent-display').querySelectorAll('fieldset .facets-layout-list input:not(:disabled)');
          let minValue = this.minNumberInput.value ? this.minNumberInput.value : this.minNumberInput.min;
          let maxValue = this.maxNumberInput.value ? this.maxNumberInput.value : this.maxNumberInput.max;

          if (handle) {
            // Store keys for current and default price range values
            const storageKey = `price_range_${handle}`;
            const defaultStorageKey = `price_range_${handle}_default`;
            const defaultValues = JSON.parse(sessionStorage.getItem(defaultStorageKey));
            
            // Save current price range values to session storage
            const rangeValues = {
              min: this.minNumberInput.value === '' || this.minNumberInput.value === this.minNumberInput.min ? '0' : this.minNumberInput.value,
              max: this.maxNumberInput.value === '' || this.maxNumberInput.value === this.maxNumberInput.max ? this.maxNumberInput.getAttribute('max') : this.maxNumberInput.value
            };
            sessionStorage.setItem(storageKey, JSON.stringify(rangeValues));

            // Check if current values match default values
            const isDefaultValues = (
              (this.minNumberInput.value === '' || this.minNumberInput.value === defaultValues.min || this.minNumberInput.value === this.minNumberInput.min) &&
              (this.maxNumberInput.value === '' || this.maxNumberInput.value === defaultValues.max || this.maxNumberInput.value === this.maxNumberInput.max)
            );

            // Update checkboxes based on price range values
            inputList.forEach(input => {
              if (isDefaultValues) {
                input.removeAttribute('checked');
              } else {
                const inputValue = parseFloat(input.value);
                if (inputValue >= parseFloat(minValue) && inputValue <= parseFloat(maxValue)) {
                  input.setAttribute('checked', '');
                } else {
                  input.removeAttribute('checked');
                }
              }
            });
          }

          this.minNumberInput.value = minValue;
          this.maxNumberInput.value = maxValue;

          // Reset URL to clean state before applying new filters
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState(null, '', newUrl);

          // Fetch and update filters with new price range values
          let searchParams = FacetFiltersForm.createSearchParams(this.closest('form'));
          let searchParamsNew;

          fetch(`${window.location.pathname}?section_id=${FacetFiltersForm.getSections()[0].section}&${searchParams}`)
            .then(response => response.text())
            .then(responseText => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const filterForm = html.querySelector('#FacetFiltersForm');
              searchParamsNew = FacetFiltersForm.createSearchParams(filterForm);
              return fetch(`${window.location.pathname}?section_id=${FacetFiltersForm.getSections()[0].section}&${searchParamsNew}`);
            })
            .then(response => response.text())
            .then(responseText => {
              // Render updated page with new filter parameters
              FacetFiltersForm.renderPage(searchParamsNew, null, true);
            })
            .catch(error => console.error("Error fetching filter data:", error));
        }, 700);
      }
    }
  }

  customElements.define('price-range', PriceRange);
}
